import { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

const ForgotPassword = () => {
  const user = useSelector((state) => state.auth.user);
  const [useremail, setUseremail] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const email = user?.email || useremail;

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
      setSuccess("تم إرسال رابط تغيير كلمة المرور إلى بريدك الإلكترونى");
    } catch (error) {
      const msg = error.response?.data?.message;
      setError(msg || "حدث خطأ أثناء إرسال رابط تغيير كلمة المرور. من فضلك حاول مرة أخرى");
    }
  };

  return (
    <div style={{height: "60vh"}} className="forgot">
      <h4>تغيير كلمة المرور</h4>
      <form onSubmit={handleResetPassword}>
        <label style={{fontSize: "0.95rem"}}>أدخل البريد الإلكترونى الخاص بحسابك</label>

        {user ? (
          <input
            type="email"
            value={user.email}
            style={{fontSize: "0.9rem", margin: "5vw auto", textAlign: "left"}}
            readOnly
          />
        ) : (
          <input
            type="email"
            onChange={(e) => setUseremail(e.target.value)}
            style={{fontSize: "0.9rem", margin: "5vw auto", textAlign: "left"}}
            required
          />
        )}

        <button type="submit" className="buttonNoBorder" style={{marginTop: "5vw"}}>تغيير كلمة المرور</button>
      </form>

      {error && <p className="error">{error}</p>}
      {success && <p style={{color: "green", width: "80vw", margin: "5vw auto"}}>{success}</p>}
    </div>
  );
};

export default ForgotPassword;
